import type * as THREE from "three";

export type ViewerControlsHandle = {
  target: THREE.Vector3;
  minDistance?: number;
  maxDistance?: number;
  update: () => void;
};

export type ViewerHandles = {
  scene: THREE.Scene | null;
  camera: THREE.PerspectiveCamera | null;
  controls: ViewerControlsHandle | null;
  renderer: THREE.WebGLRenderer | null;
};

const state: ViewerHandles = {
  scene: null,
  camera: null,
  controls: null,
  renderer: null,
};

export function setViewerHandles(next: Partial<ViewerHandles>) {
  if (!next || typeof next !== "object") return;
  if ("scene" in next) state.scene = next.scene ?? null;
  if ("camera" in next) state.camera = next.camera ?? null;
  if ("controls" in next) state.controls = next.controls ?? null;
  if ("renderer" in next) state.renderer = next.renderer ?? null;
}

export function clearViewerHandles() {
  state.scene = null;
  state.camera = null;
  state.controls = null;
  state.renderer = null;
}

export function getViewerHandles(): ViewerHandles {
  return state;
}
